import React from 'react';
import {
  AppWrapperContainer,
  ContentContainer,
  FooterContainer,
  HeaderContainer,
} from './AppWrapper.styled';
import { useLocation } from 'react-router-dom';
import { AppHeader } from '../../common/sharedComponents/AppHeader';
import { getHeaderTitle } from './utils';
import { BottomNavigationBar } from './BottomNavigationBar';

export interface IAppWrapper {
  children: React.ReactNode;
}

export function AppWrapper ({ children }: IAppWrapper) {
  const location = useLocation();
  const headerTitle = getHeaderTitle(location.pathname);
  return (
    <AppWrapperContainer>
      <HeaderContainer>
        <AppHeader title={headerTitle} />
      </HeaderContainer>
      <ContentContainer>{children}</ContentContainer>
      <FooterContainer>
        <BottomNavigationBar />
      </FooterContainer>
    </AppWrapperContainer>
  );
}
